import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpService } from '.';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PromoService {
  private PROMOLIST: any;
  private contactDetailsSubject = new BehaviorSubject<any>(null);
  contactDetails$ = this.contactDetailsSubject.asObservable();
  private loginStatus = new BehaviorSubject<boolean>(!!localStorage.getItem('FlightLoginToken'));
  loginStatus$ = this.loginStatus.asObservable();
  promoCode: string | null = null; 

  constructor(private http: HttpService) {}

  savePromoCode(code: string): void {
    this.promoCode = code;
  }

  getPromoCode(): string | null {
    return this.promoCode ;
  }
  
  setContactDetails(details: any): void {
    const flightCheckUser = JSON.parse(localStorage.getItem('Flightcheck-user') || '{}');
    this.contactDetailsSubject.next(flightCheckUser);
  }
  
  setLoginStatus(status: boolean) {
    this.loginStatus.next(status);
  }

  getPROMO_LIST(): Observable<any> {
    if (this.PROMOLIST) {
      return of(this.PROMOLIST);
    }
    return this.http.flightgetall(`apiV2/bookingClass/promo-list`).pipe(
      map(res => {
        if(res.statusCode === 200) {
          this.PROMOLIST = res.data;
          return this.PROMOLIST;
        } else {
          throw new Error('Failed to fetch Promo List');
        }
      }), catchError(err => {
        return of([])
      })
    )
  }
}
